import type { Router } from "vue-router";
import { GlobalSearchType, type GSSearchV2Query } from "@/graphql";
import { navigateToSQDCTile } from "@/modules/sqdc/helper/SQDCTileNavigation";

export type GlobalSearchResult = GSSearchV2Query["GSSearchV2"]["results"][number];

export async function navigateToGlobalSearchResult(router: Router, result: GlobalSearchResult) {
  if (result.href) {
    await router.push(result.href);
    return;
  }
  if (result.type === GlobalSearchType.KPI_BOARD && result.boardId != null) {
    await router.push({ name: "KPIBoardNew", params: { boardId: result.boardId } });
    return;
  }
  if (
    result.type === GlobalSearchType.KPI_TILE &&
    result.boardId != null &&
    result.tileId != null
  ) {
    await navigateToSQDCTile(router, result.boardId, result.tileId);
    return;
  }
  if (
    (result.type === GlobalSearchType.SQDC_EVENT || result.type === GlobalSearchType.SQDC_ACTION) &&
    result.boardId != null &&
    result.eventId != null
  ) {
    const isAction = result.type === GlobalSearchType.SQDC_ACTION && result.actionId != null;
    const query: Record<string, string> = {
      scrollToId: String(isAction ? result.actionId : result.eventId),
      scrollToEntity: isAction ? "action" : "event",
    };
    await router.push({
      name: "EventActionBoardNew",
      params: { boardId: result.boardId },
      query,
    });
  }
}
